export const initialState = (page = {}) => ({
  id: page.id,
  image_url: null,
})

export const answerUpdate = (state = initialState(), payload) => ({
  ...state,
  image_url: ((payload === undefined ? 'debug-image-url.png' : payload[`image_${state.id}`])),
})

export default { initialState, answerUpdate }



// WEBPACK FOOTER //
// ./src/reducers/Missions/Answers/photo.jsx